var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgKetogainsLogoSmall = function SvgKetogainsLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "38px",
    viewBox: "0 0 37 38"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Asset 1")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Portal-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-Unsync",
    transform: "translate(-141.000000, -42.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(16.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset-1",
    transform: "translate(125.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,38 L4,29.4990685 L4,12.4990685 L18.5,4 L33,12.4990685 L33,29.4990685 L18.5,38 Z M6.13829114,28.2415342 L18.5,35.4886575 L30.8635443,28.2415342 L30.8635443,13.7547397 L18.5,6.51134247 L6.13829114,13.7547397 L6.13829114,28.2415342 Z",
    id: "Shape",
    fill: "#5E5F5D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF5000",
    points: "17.4716686 22 0 31.9405346 7.19421649 36 17.4716686 30.1533006 27.780383 35.9751773 35 31.9004364"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF2A07",
    points: "28.0466792 4.56044657 20 0 20 19.3555343 37 29 37 20.4840829 28.0466792 15.405614"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DD2321",
    points: "17 19.3105752 17 0 8.95332077 4.54854925 8.95332077 15.3709595 0 20.4730848 0 29"
  })))))));
};

export default __webpack_public_path__ + "static/media/ketogains-logo-small.9c572f8b.svg";
export { SvgKetogainsLogoSmall as ReactComponent };